"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticEntity = void 0;
class AnalyticEntity {
    id;
    display;
    media;
    reqId;
    method;
    originalUrl;
    userAgent;
    referrer;
    forwardedFor;
    ip;
    ips;
    organization_name;
    asn;
    organization;
    longitude;
    area_code;
    latitude;
    ua;
    // Campos geográficos adicionales
    continent_code;
    region;
    accuracy;
    country;
    city;
    timezone;
    country_code;
    country_code3;
    request;
    browser;
    cpu;
    device;
    engine;
    os;
    /**
     * @deprecated
     */
    create_at;
    createdAt;
    updatedAt;
}
exports.AnalyticEntity = AnalyticEntity;
